import * as React from 'react';
import * as ReactDOM from 'react-dom';
import HomePage from './pages/HomePage';
import UploadPage from './pages/UploadPage';
import ErrorPage from './pages/ErrorPage';
import { Switch, Route, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { CssBaseline, AppBar, Toolbar, Typography, makeStyles, Button, Icon, Container } from '@material-ui/core';
import HideOnScroll from './components/HideOnScroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileUpload } from '@fortawesome/pro-duotone-svg-icons/faFileUpload'
import { useAuthenticationSelector, AuthenticationSelectors } from './store/modules/authentication';

export interface IAppProps {

}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            paddingTop: 64
        }
    },
    menuButton: {
        marginRight: theme.spacing(2),
        // '--fa-primary-color': theme.palette.primary.dark,
        // '--fa-secondary-color': theme.palette.secondary.light
    },
    title: {
        flexGrow: 1
    },
    container: {
        padding: theme.spacing(3)
    }
}));


export const App: React.FC<IAppProps> = ({

}) => {
    const classes = useStyles()
    const user = useAuthenticationSelector(AuthenticationSelectors.selectUser);

    return (
        <>
            <CssBaseline />
            <HideOnScroll>
                <AppBar>
                    <Toolbar>
                        <FontAwesomeIcon
                            icon={faFileUpload}
                            size="2x"
                            className={classes.menuButton}
                        />
                        <Typography variant="h6" className={classes.title}>Quickbooks Importer</Typography>
                        {
                            user ?
                                <>
                                    {
                                        // <Button color="inherit" component={Link} to="/home">Home</Button>
                                        // <Button color="inherit" component={Link} to="/import">Import</Button>
                                    }
                                    <Button component="a" href="/auth/logout" color="inherit">Logout</Button>
                                </> :
                                <>
                                    <Button component="a" href="/auth/quickbooks" color="inherit">Login</Button>
                                </>
                        }
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
            <div className={classes.container}>
                {
                    user ?
                        <Switch>
                            <Route path="/import" component={UploadPage} />
                            <Route path="/error/:errorCode" component={ErrorPage} />
                            <Route path="/error" component={ErrorPage} />
                            <Redirect path="/home" exact to="/import" />
                            <Redirect path="/" exact to="/import" />
                            <Redirect path="*" to="/error/404" />
                        </Switch> :
                        <Switch>
                            <Route path="/home" component={HomePage} />
                            <Route path="/error/:errorCode" component={ErrorPage} />
                            <Route path="/error" component={ErrorPage} />
                            <Redirect path="/import" exact to="/error/401" />
                            <Redirect path="/" exact to="/home" />
                            <Redirect path="*" exact to="/error/404" />
                        </Switch>
                }
            </div>
        </>
    )
}



// WEBPACK FOOTER //
// ./src/App.tsx